import React, { Component } from 'react'
import NewsItems from './NewsItems'
import PropTypes from 'prop-types'


export class News extends Component {

    static defaultProps = {
        category: "india",
        searchUrl: null
    }
    static propTypes = {
        category: PropTypes.string,
    }

    // __________________________Articles___________________________________
    articles = [
        {
            "source": {
                "id": null,
                "name": "The Indian Express"
            },
            "author": "Entertainment Desk",
            "title": "68th National Film Awards winners list: Suriya's Soorarai Pottru wins big - The Indian Express",
            "description": "68th National Film Awards winners: Suriya starrer Soorarai Pottru bagged multiple awards at the 68th National Film Awards. The Best Actor trophy was shared by Suriya and Ajay Devgn.",
            "url": "https://indianexpress.com/article/entertainment/bollywood/68th-national-film-awards-winners-list-8045178/",
            "urlToImage": "https://images.indianexpress.com/2020/11/suriya-1200.jpg",
            "publishedAt": "2022-07-22T12:01:05Z",
            "content": "The winners of the 68th National Film Awards were announced today in New Delhi. Established in 1954, the prestigious awards are administered by the Government of India’s Directorate of Film Festivals… [+4801 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Moneycontrol"
            },
            "author": "Gaurav Sharma",
            "title": "Reliance Jio Q1 Results | Net profit rises 24%, topline 21.6% on higher per-user revenue - Moneycontrol",
            "description": "The growth in revenues during the quarter was driven by increase in ARPU as well as a modest addition to its subscriber base.",
            "url": "https://www.moneycontrol.com/news/business/earnings/reliance-jio-q1-results-net-profit-rises-24-topline-21-6-on-higher-per-user-revenue-8868591.html",
            "urlToImage": "https://images.moneycontrol.com/static-mcnews/2017/03/reliance_jio_data_network_cellular_mobile_internet_720-770x433.jpg",
            "publishedAt": "2022-07-22T11:49:09Z",
            "content": "Reliance Jio Infocomm, a subsidiary of Jio Platforms, reported a year-on-year growth of 23.8 percent in its standalone net profit of Rs 4,335 crore for the quarter ended June 2022 (Q1FY23) compared t… [+1543 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "Hindustan Times"
            },
            "author": "HT News Desk",
            "title": "Supreme Court's direction to Centre on security cover for Mukesh Ambani, family - Hindustan Times",
            "description": "Ambani, according to reports, has Z+ security - the highest category of security cover provided by the ministry of home affairs, based on the level of threat perception. | Latest News India",
            "url": "https://www.hindustantimes.com/india-news/supreme-court-s-direction-to-centre-on-security-cover-for-mukesh-ambani-family-101658486622661.html",
            "urlToImage": "https://images.hindustantimes.com/img/2022/07/22/1600x900/94510a6e-6a3f-11ec-b1d1-ef9e01dbbdfc_1646907082720_1658486891373_1658486891373.jpg",
            "publishedAt": "2022-07-22T10:50:05Z",
            "content": "The Supreme Court on Friday allowed the Centre to continue with the security cover for industrialist Mukesh Ambani and his family members in Mumbai. The order by the Supreme Court bench -- headed by … [+1258 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "News18"
            },
            "author": "Buzz Staff",
            "title": "Twitter Thread Decodes the Oldest Galaxy Spotted by James Webb Space Telescope - News18",
            "description": "Named GLASS-z13, this galaxy is reported to date back to 300 million years after the big bang.",
            "url": "https://www.news18.com/news/buzz/twitter-thread-decodes-the-oldest-galaxy-spotted-by-james-webb-space-telescope-5605945.html",
            "urlToImage": "https://images.news18.com/ibnlive/uploads/2022/07/untitled-design-6-13-165848691516x9.jpg",
            "publishedAt": "2022-07-22T10:49:40Z",
            "content": "James Webb Space Telescope, the most powerful machine that humans have ever built to peek into the universe, released its first, jaw-dropping deep field images a week ago. And naturally, it took the … [+4095 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "NDTV News"
            },
            "author": null,
            "title": "\"Not Time For Whataboutery\": Opposition Veep Candidate To Mamata Banerjee - NDTV",
            "description": "Margaret Alva, the joint opposition candidate running for Vice President, has criticised the Trinamool Congress's decision to abstain from voting in the election.",
            "url": "https://www.ndtv.com/india-news/not-the-time-for-whataboutery-oppositions-vice-president-candidate-margaret-alva-to-mamata-banerjee-3183586",
            "urlToImage": "https://i.ndtvimg.com/i/2016-07/margaret-alva_650x400_81468694725.jpg",
            "publishedAt": "2022-07-22T10:30:00Z",
            "content": "Margaret Alva is the joint opposition candidate running for Vice President\r\nNew Delhi: Margaret Alva, the joint opposition candidate running for Vice President, has criticised the Trinamool Congress'… [+2624 chars]"
        },
        {
            "source": {
                "id": "google-news",
                "name": "Google News"
            },
            "author": null,
            "title": "Share Market Highlights: Sensex ends 390 pts higher, Nifty above 16700; HDFC Bank twins, ICICI Bank lead gains - The Financial Express",
            "description": null,
            "url": "https://news.google.com/__i/rss/rd/articles/CBMiuQFodHRwczovL3d3dy5maW5hbmNpYWxleHByZXNzLmNvbS9tYXJrZXQvc2hhcmUtbWFya2V0LXRvZGF5LWxpdmUtdXBkYXRlcy1zZW5zZXgtbmlmdHktcnVwZWUtdnMtZG9sbGFyLXNneC1uaWZ0eS1oaW50cy1hdC1hLXBvc2l0aXZlLXN0YXJ0LXJlbGlhbmNlLXExLXJlc3VsdHMtZXllZC0yMi1qdWx5LWZyaWRheS8yNjAyMjA5L9IBAA?oc=5",
            "urlToImage": null,
            "publishedAt": "2022-07-22T10:28:51Z",
            "content": null
        },
        {
            "source": {
                "id": null,
                "name": "NDTV News"
            },
            "author": "NDTV Sports Desk",
            "title": "\"I Would Be Trying To Find Every Way\": Ricky Ponting Wants India To Play Both These Stars In T20 Wor.. - NDTV Sports",
            "description": "Ricky Ponting feels that both wicketkeeper-batters are in top form, and having both players in the team might benefit Team India.",
            "url": "https://sports.ndtv.com/cricket/i-would-be-trying-to-find-every-way-ricky-ponting-wants-india-to-play-both-these-stars-in-t20-world-cup-3183284",
            "urlToImage": "https://c.ndtvimg.com/2021-12/q28o09d8_ricky-ponting-afp_625x300_17_December_21.jpg?im=FeatureCrop,algorithm=dnn,width=1200,height=675",
            "publishedAt": "2022-07-22T10:25:52Z",
            "content": "Former Australia captain Ricky Ponting feels India should find a way to include both Rishabh Pant and Dinesh Karthik in their playing XI for the T20 World Cup. Ponting feels that both wicketkeeper-ba… [+1379 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "News18"
            },
            "author": "News Desk",
            "title": "From 'Savarkar Ki Aulaad' to 'Drunk Ladies', Row Over Delhi Excise Policy Hits New Low as CBI Probe Looms - News18",
            "description": "Delhi CM Arvind Kejriwal has alleged that the L-G’s recommendation of a CBI probe into the Excise Policy 2021-22 is part of a political vendetta against Manish Sisodia and the AAP",
            "url": "https://www.news18.com/news/politics/from-savarkar-ki-aulaad-to-drunk-ladies-row-over-delhi-excise-policy-hits-new-low-as-cbi-probe-looms-5606275.html",
            "urlToImage": "https://images.news18.com/ibnlive/uploads/2022/07/sisodia-kejriwal-165848474816x9.png",
            "publishedAt": "2022-07-22T10:12:56Z",
            "content": "Delhi Chief Minister Arvind Kejriwal on Friday mounted a strong defence of his deputy Manish Sisodia after Lieutenant Governor VK Saxena recommended a CBI probe into the AAP governments Excise Policy… [+5027 chars]"
        },
        {
            "source": {
                "id": "google-news",
                "name": "Google News"
            },
            "author": null,
            "title": "People With Hypertension At High Risk For Severe COVID-19 Illness Even After A Booster | TheHealthSite.co - TheHealthSite",
            "description": null,
            "url": "https://news.google.com/__i/rss/rd/articles/CBMigQFodHRwczovL3d3dy50aGVoZWFsdGhzaXRlLmNvbS9uZXdzL3Blb3BsZS13aXRoLWh5cGVydGVuc2lvbi1hdC1oaWdoLXJpc2stZm9yLXNldmVyZS1jb3ZpZC0xOS1pbGxuZXNzLWV2ZW4tYWZ0ZXItYS1ib29zdGVyLTg5NTc3Mi_SAQA?oc=5",
            "urlToImage": null,
            "publishedAt": "2022-07-22T09:36:00Z",
            "content": null
        },
        {
            "source": {
                "id": null,
                "name": "Hindustan Times"
            },
            "author": "HT Entertainment Desk",
            "title": "Alia Bhatt calls Shamshera release ‘Kapoor Day’, shares pic in customised tee - Hindustan Times",
            "description": "Alia Bhatt shared an Instagram post on the occasion of husband Ranbir Kapoor's film release, Shamshera, on Friday. She is seen wearing a tee with ‘Kapoor’ written on it.",
            "url": "https://www.hindustantimes.com/entertainment/bollywood/alia-bhatt-calls-release-of-ranbir-kapoor-starrer-shamshera-kapoor-day-shares-pic-in-customised-tee-101658479321522.html",
            "urlToImage": "https://images.hindustantimes.com/img/2022/07/22/1600x900/Collage_Maker-22-Jul-2022-02.29-PM_1658480378829_1658480390441_1658480390441.jpg",
            "publishedAt": "2022-07-22T09:25:43Z",
            "content": "Alia Bhatt has dedicated a post to husband Ranbir Kapoor whose film Shamshera released in theatres on Friday. The Karan Malhotra film marks Ranbir's return to the silver screen after four years. Prom… [+1707 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "NDTV News"
            },
            "author": null,
            "title": "Liger: Ranveer Singh Trolls Vijay Deverakonda's Chappals, Then Wants T-Shirt Swap. What Happened Next - NDTV Movies",
            "description": "Ranveer Singh asked Vijay Deverakonda for his t-shirt at the trailer launch event of Liger",
            "url": "https://www.ndtv.com/entertainment/liger-ranveer-singh-trolls-vijay-deverakondas-chappals-then-wants-t-shirt-swap-what-happened-next-3183266",
            "urlToImage": "https://c.ndtvimg.com/2022-07/0g61f6mo_vijay_625x300_22_July_22.jpg",
            "publishedAt": "2022-07-22T08:53:38Z",
            "content": "Vijay Deverakonda and Ranveer Singh at Liger trailer launch. (courtesy: ndtvmovies)\r\nNew Delhi: The trailer launch event of Liger, which took place on Thursday, had lots of hilarious moments, thanks … [+2319 chars]"
        },
        {
            "source": {
                "id": null,
                "name": "EastMojo"
            },
            "author": "Press Trust of India",
            "title": "AstraZeneca, Pfizer COVID vaccines offer protection 6 months after 2nd dose: Study - EastMojo",
            "description": "London: Two doses of Pfizer and AstraZeneca vaccines provide high protection against severe COVID-19 up to six months after the second shot,",
            "url": "http://www.eastmojo.com/world/2022/07/22/astrazeneca-pfizer-covid-vaccines-offer-protection-6-months-after-2nd-dose-study/",
            "urlToImage": "https://i0.wp.com/www.eastmojo.com/wp-content/uploads/2021/05/covid-19-vaccine.jpg?fit=1280%2C720&ssl=1",
            "publishedAt": "2022-07-22T08:52:17Z",
            "content": "London: Two doses of Pfizer and AstraZeneca vaccines provide high protection against severe COVID-19 up to six months after the second shot, according to a study published in The BMJ.\r\nThe team led b… [+2750 chars]"
        }
    ]
    // __________________________End of Articles___________________________________




    constructor() {
        super()
        this.state = {
            articles: this.articles,
            loading: false,
            number_of_articles: 12
        }
    }

    // async componentDidMount() {
    //     this.setState({ loading: true })
    //     let url = `https://newsapi.org/v2/top-headlines?country=in&category=${this.props.category}&apiKey=d16597cdb40841e88f3ff8025f53224a&pageSize=${this.state.number_of_articles}`
    //     let data = await fetch(url)
    //     let parsedData = await data.json()
    //     this.setState({
    //         articles: parsedData.articles,
    //         loading: false
    //     })
    // }

    async componentDidMount() {
        console.log("this.props.searchUrl: ", this.props.searchUrl, " inside news.js ")
        if ((this.props.searchUrl) === null) {
            this.setState({ loading: true })
            let url = `https://newsapi.org/v2/top-headlines?country=in&category=${this.props.category}&apiKey=d16597cdb40841e88f3ff8025f53224a&pageSize=${this.state.number_of_articles}`
            let data = await fetch(url)
            let parsedData = await data.json()
            this.setState({
                articles: parsedData.articles,
                loading: false
            })
        }
        //below code will show news that are searched by user
        else {
            this.setState({ loading: true })
            let url = (`${this.props.searchUrl}&pageSize=${this.state.number_of_articles}`)
            let data = await fetch(url)
            let parsedData = await data.json()
            this.setState({
                articles: parsedData.articles,
                loading: false
            })
        }


    }

    scroll_to_top = () => {
        window.scrollTo(0, 0)
    }

    // loadMore = async () => {
    //     this.setState({ number_of_articles: this.state.number_of_articles + 12 })
    //     this.setState({ loading: true })
    //     let url = `https://newsapi.org/v2/top-headlines?country=in&category=${this.props.category}&apiKey=d16597cdb40841e88f3ff8025f53224a&pageSize=${this.state.number_of_articles}`

    //     let data = await fetch(url)
    //     let parsedData = await data.json()
    //     this.setState({
    //         articles: parsedData.articles,
    //         loading: false
    //     })
    // }

    loadMore = async () => {
        if ((this.props.searchUrl) === null) {
            this.setState({ number_of_articles: this.state.number_of_articles + 12 })
            this.setState({ loading: true })
            let url = `https://newsapi.org/v2/top-headlines?country=in&category=${this.props.category}&apiKey=d16597cdb40841e88f3ff8025f53224a&pageSize=${this.state.number_of_articles}`

            let data = await fetch(url)
            let parsedData = await data.json()
            this.setState({
                articles: parsedData.articles,
                loading: false
            })
        }
        else{
            this.setState({ number_of_articles: this.state.number_of_articles + 12 })
            this.setState({ loading: true })
            // let url = `https://newsapi.org/v2/top-headlines?country=in&category=${this.props.category}&apiKey=d16597cdb40841e88f3ff8025f53224a&pageSize=${this.state.number_of_articles}`
            let url = (`${this.props.searchUrl}&pageSize=${this.state.number_of_articles}`)
            let data = await fetch(url)
            let parsedData = await data.json()
            this.setState({
                articles: parsedData.articles,
                loading: false
            })
        }

    }


    render() {

        let null_image = 'https://nextjsdev.com/content/images/2021/11/news.png'
        let default_title = "Quo, rem, aliquid maxime itaque commodi cumque asperiores eveniet porro ratione fuga placeat..."
        let default_desc = "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo, rem, aliquid maxime itaque commodi cumque asperiores eveniet porro ratione fuga placeat optio modi qui. A sunt officiis..."

        return (
            <div className="containerOfNewsContainer">
                <h1>Top Headlines</h1>
                <div className='newsContainer'>
                    {!this.state.loading && this.state.articles.map((element) => {
                        return (
                            <div key={element.url}>
                                <NewsItems
                                    img={element.urlToImage != null ? element.urlToImage : null_image}
                                    title={element.title != null ? element.title.slice(0, 96) + "..." : default_title}
                                    description={element.description != null ? element.description.slice(0, 190) + "..." : default_desc}
                                    newsUrl={element.url} />
                            </div>
                        )
                    })}


                </div>
                <div className="btnContainer">
                    <button type="button" onClick={this.scroll_to_top}>Scroll to top</button>

                    <div className="loadingbtn_and_LoadMore">
                        {/* (this.state.loading &&) it means below div will be shown only if {this.state.loading} condition will be True*/}
                        {this.state.loading &&
                            <div id='loadingDiv'>
                                <div id="circle"></div>
                            </div>}
                        <button type="button" onClick={this.loadMore}>Load More</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default News
